import React, { Component } from 'react';
import PropTypes from 'prop-types';
import HeaderNavLink from './HeaderNavLink';

export class MenuLargeNavigation extends Component {
  static propTypes = {
    navList: PropTypes.arrayOf(
      PropTypes.shape({
        to: PropTypes.string.isRequired,
        className: PropTypes.string.isRequired,
        children: PropTypes.isRequired,
      }),
    ).isRequired,
    hideMenu: PropTypes.func.isRequired,
  };

  render() {
    return (
      <div className="menu-large-navigation">
        {this.props.navList.map((item, i) => (
          <li key={i} className={item.active ? '-active' : ''}>
            <HeaderNavLink
              to={item.to}
              className={item.className}
              hideMenu={this.props.hideMenu}
            >
              {item.label}
            </HeaderNavLink>
          </li>
        ))}
      </div>
    );
  }
}
